import { Box, Text, VStack } from "@chakra-ui/react";
import { surfaceShadow } from "../constants";

export function SectionCard({
  title,
  description,
  children,
  ...rest
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
} & React.ComponentProps<typeof Box>) {
  return (
    <Box bg="white" borderRadius="xl" boxShadow={surfaceShadow} p={4} {...rest}>
      <VStack align="stretch" gap={4}>
        <Box>
          <Text fontFamily="heading" fontSize="md" fontWeight="medium" color="gray.900" lineHeight="snug">{title}</Text>
          {description && <Text fontSize="sm" color="gray.500" mt={1}>{description}</Text>}
        </Box>
        {children}
      </VStack>
    </Box>
  );
}
